module.exports = __webpack_public_path__ + "media/images/pic/teachers/kaede-funakoshi-d9f6ba93acda9edf988f824eec4f50b9.webp";